import react from "react";
import styles from "./working.module.css";
import { ReactComponent as Address } from "../../../../../assests/working/address.svg";
import { ReactComponent as Contact } from "../../../../../assests/working/contact.svg";
import { ReactComponent as Hour } from "../../../../../assests/working/hour.svg";

function Working() {
  return (
    <div id="support" className={styles.working_wrapper}>
      <div className={styles.working_container}>
        <div className={styles.hour}>
          <Hour width={50} height={50} className={styles.hourSVG} />
          <h2>Working Hours</h2>
          <p>
            MONDAY - FRIDAY: 9:00 - 18:00 <br /> SATARDAY: CLOSED <br />
            SUNDAY: CLOSED
          </p>
        </div>
        <div className={styles.address}>
          <Address width={50} height={50} className={styles.addressSVG} />
          <h2>Office Address</h2>
          <p>
            22 BIS AVENUE DU MAI 1945 <br /> 95200 SARCELLES
          </p>
        </div>
        <div className={styles.contact}>
          <Contact width={50} height={50} className={styles.contactSVG} />
          <h2>Contact Info</h2>
          <p>
            CONTACT@BUSINESSCORNERS.ONLINE <br /> +33 09 73 62 18 08
          </p>
        </div>
      </div>
    </div>
  );
}

export default Working;
